export const API_BASE = import.meta.env?.VITE_API_BASE;
export const DOMAIN = import.meta.env?.VITE_BASE_DOMAIN;
export const FB_APP_ID = import.meta.env?.VITE_FB_APP_ID;
export const APP_VERSION = import.meta.env?.VITE_APP_VERSION;
export const MEDIA_URL =
  import.meta.env?.VITE_MEDIA_URL || "https://d2xph3acigfefx.cloudfront.net/";

export const getMediaUrl = (path?: string | null): string => {
  if (!path) return "";
  if (
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("blob:") ||
    path.startsWith("data:")
  ) {
    return path;
  }
  const cleanBase = MEDIA_URL.endsWith("/") ? MEDIA_URL : `${MEDIA_URL}/`;
  const cleanPath = path.replace(/^\//, "");
  return `${cleanBase}${cleanPath}`;
};

